export default __webpack_public_path__ + "static/media/imgLightEn3.5c9bca56.png";